import { ReferralInfo } from '../../utils/bi/consts';
import { NavigateToNextPageAction } from '../navigateToNextPage/navigateToNextPage';
import { OnBookFlowStartAttemptAction } from '../onBookFlowStartAttempt/onBookFlowStartAttempt';
import { NavigationTarget } from '../navigateToNextPage/consts';
import { EnrichedService } from '../../types/types';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { bookingsUoUBookNowClickSrc16Evid1190 } from '@wix/bi-logger-bookings-data/v2';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export type OnActionButtonClickAction = ({
  service,
  referralInfo,
}: {
  service: EnrichedService;
  referralInfo: ReferralInfo;
}) => Promise<void>;

export const createOnActionButtonClickAction = ({
  navigateToNextPage,
  onBookFlowStartAttempt,
  flowAPI,
}: {
  navigateToNextPage: NavigateToNextPageAction;
  onBookFlowStartAttempt: OnBookFlowStartAttemptAction;
  flowAPI: ControllerFlowAPI;
}): OnActionButtonClickAction => {
  return async ({ service, referralInfo }) => {
    flowAPI.bi?.report(
      bookingsUoUBookNowClickSrc16Evid1190({ service_id: service.id! }),
    );

    if (service.type === ServiceType.COURSE || service.displayOnlyNoBookFlow) {
      return navigateToNextPage({
        target: NavigationTarget.SERVICE_PAGE,
        service,
        referralInfo,
      });
    } else {
      return onBookFlowStartAttempt({ service, referralInfo });
    }
  };
};
